export default {
  getShopId: state => {
    return state.shopId;
  },
  getToken: state => {
    return state.token;
  },
  getShopifyToken: state => {
    return state.shopifyToken;
  },
  getAuthenticated: state => {
    return !!state.token;
  },
};
